import { PriorityRatingType, getPriorityRatingText } from '@/features/types';
import classes from './PriorityRating.module.css';

const VARIANT_CLASS: Record<PriorityRatingType, string> = {
  [PriorityRatingType.P1]: classes.priorityLevelP1,
  [PriorityRatingType.P2]: classes.priorityLevelP2,
  [PriorityRatingType.P3]: classes.priorityLevelP3,
  [PriorityRatingType.P4]: classes.priorityLevelP4,
  [PriorityRatingType.P5]: classes.priorityLevelP5,
  [PriorityRatingType.Unknown]: classes.priorityLevelUnknown,
};

type Props = {
  priorityRating: PriorityRatingType | undefined;
};

export const PriorityRating = (props: Props) => {
  // Backend coalesces missing WPL rows to 0 (e.g. for `flag-wildfire=fuels-only` spans
  // and any span without a source row). Treat both 0 and undefined as the Unknown variant
  // so the styled pill matches the "Unknown" label `getPriorityRatingText` returns.
  const variant =
    props.priorityRating && props.priorityRating in VARIANT_CLASS
      ? props.priorityRating
      : PriorityRatingType.Unknown;
  return (
    <div
      data-testid="priority-rating"
      className={`${classes.priorityLevel} ${VARIANT_CLASS[variant]}`}
    >
      <span>
        {getPriorityRatingText(
          props.priorityRating ?? PriorityRatingType.Unknown
        )}
      </span>
    </div>
  );
};
